import { loadScript } from '@paypal/paypal-js';

export default (_, inject) => {
  inject('paypalSdk', (options) => loadScript(options));
};
